import React ,{ useState,useContext,useEffect  } from "react";
import { Link } from "react-router-dom";
import MenuIcon from "../assets/icons/headerIcons/menu.svg"; // Menu icon
import WhatsAppIcon from "../assets/icons/headerIcons/whatsapp.svg"; // WhatsApp icon
import LogoIcon from "../assets/icons/headerIcons/shopName.svg"; // Path to the logo
import LogoPic from "../assets/images/Logo.png";
import Sidebar from "./AdminSidebar";
import { UserContext } from "../pages/UserContext";
import ShopNameSVG from "./ShopNameSVG";

const AdminHeader = () => {

   const { user } = useContext(UserContext); // Get user from UserContext

  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const [settings, setSettings] = useState({
    shopName: "Shop Name",
    shopLogo: "",
  });
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const [isLoaded, setIsLoaded] = useState(false);
  const logoUrl = settings.shopLogo;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setSettings({
            shopName: data.shop_name || "Shop Name",
            shopLogo: data.logo_white || "/assets/images/default-logo.png", // Default logo fallback
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
      });
  }, []);

  return (
    <>
     <header className="fixed top-0 left-0 w-full bg-white px-4 py-1 shadow-md z-10 flex items-center justify-between md:px-6 h-14">
      {/* Menu Icon - Visible only on mobile */}
      <button onClick={toggleSidebar} className="text-gray-700">
          <img
          src={MenuIcon}
          alt="Menu Icon"
          className="w-5 h-6 object-contain" // Ensures the SVG scales proportionally
         />
      </button>

      {/* Logo Section */}
      <Link to="/admin-dashboard">
      <div className="flex items-center md:ml-0 ">
        
        {/* <img src={LogoPic} alt="Shop Logo" className="h-10" /> */}
      {!isLoaded && (
        <img
          src="/assets/images/transparent.png"
          alt="Placeholder"
          className="h-10 absolute inset-0"
        />
      )}

      {/* Actual shop logo image */}
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Shop Logo"
          className="h-10"
          style={{ visibility: isLoaded ? "visible" : "hidden" }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setIsLoaded(true)}
        />
      )}
        {/* <div className="mt-2 ml-1">
          <img
            src={LogoIcon}
            alt="Shop Name"
            className="h-12 translate-y-1"
          />
        </div>    */}
         <ShopNameSVG shopName={settings.shopName} colour="black" />
      </div>
      </Link>

      <div className="w-6 h-6"></div>
    </header>
     {/* Sidebar Component */}
     <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} userName={user?.name || "User"} />
     </>
  );
};

export default AdminHeader;
